
import { useState, useEffect } from 'react';
import { fetchProviderStatus } from '@/services/providerStatusService';

export const useProviderSubscription = (user_id: string | undefined, providerId: string) => {
  const [isPremiumProvider, setIsPremiumProvider] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkProviderSubscription = async () => {
      if (!user_id) { setIsLoading(false); return; }
      setIsLoading(true);
      const status = await fetchProviderStatus(user_id);
      setIsPremiumProvider(!!status?.isPremium);
      setIsLoading(false);
    };
    checkProviderSubscription();
  }, [user_id, providerId]);

  return { isPremiumProvider, isLoading };
};
